import React from 'react';
import { css } from '@emotion/css';
import turtleIllustration from '@/assets/turtle.svg';
import { ButtonFlatMedium } from '@/design-system';
import { EmptyState } from '../EmptyState';

type Props = {
  onClick: () => void;
};

export const FilterOnEmptyState: React.FC<Props> = ({ onClick }) => {
  return (
    <EmptyState
      title="Currently no flyers that match your filter."
      description="Reset your filter to view other flyers."
      bottom={
        <ButtonFlatMedium onClick={onClick} className={styles.link}>
          Reset Filters
        </ButtonFlatMedium>
      }
      illustration={turtleIllustration}
    />
  );
};

const styles = {
  link: css`
    padding-bottom: 47px;
  `,
};
